import { useSelector } from "react-redux";

const IN_PROGRESS_FLAGS = [
  "isReportUnsigning",
  "isReportArchiving",
  "isReportProcessing",
  "isReportUnProcessing",
  "isSignAndProcessing",
  "isSignAndUnProcessing",
  "isReportNoteSubmitting",
  "isReportNoteSubmittingAndProcessing",
  "isUpdatingReportNotes",
  "clinicNoteSubmitting",
  "clinicNoteSubmittingAndProcessing",
  "clinicNoteSubmittingAndSigningAndProcessing",
  "clinicNoteSubmittingAndSigningAndUnProcessing",
  "providerNoteSubmitting",
  "providerNoteSubmittingAndProcessing",
  "providerNoteSubmittingAndSigningAndProcessing",
  "providerNoteSubmittingAndSigningAndUnProcessing",
];

const useNoteButtonActionInProgress = () =>
  useSelector((state) =>
    IN_PROGRESS_FLAGS.some((flag) => state.transmission[flag])
  );

export default useNoteButtonActionInProgress;
